import React from "react";
import { FC, Fragment } from "react";
import "./Footer.css";

const Footer: FC = () =>  {
  return <Fragment>
      <div className="footer--container">
        <div className="footer--content">
          <div>
          © Workshop Service Assist, all rights reserved
          </div>
          <div className="link-redirect"><a href="/vhc/data-protection-notice">Data protection notice</a></div>
        </div>
      </div>
    </Fragment>
}

export default Footer;
